import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = require('./firebase-config.json')

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { app, messaging };
